import { motion } from "framer-motion";
import { ArrowUpRight, MessageCircle } from "lucide-react";
import { MAPS_EMBED, MAPS_DIRECTIONS, waLink } from "@/lib/constants";

const EASE = [0.16, 1, 0.3, 1];

export const Location = () => (
  <section id="contato" className="py-20 lg:py-28 bg-surface">
    <div className="px-4 sm:px-6 lg:px-10 max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
      >
        <p className="flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.3em] text-gray-500 mb-6">
          <span className="text-signal">07</span>
          <span className="h-px w-10 bg-signal/60" />
          Onde Estamos
        </p>
        <h2 className="font-display font-black uppercase tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl text-white">
          No Centro de Balneário Camboriú, <span className="text-signal">perto de você.</span>
        </h2>
        <p className="mt-6 text-sm sm:text-base text-gray-400 leading-relaxed max-w-xl">
          Oficina mecânica no Centro de Balneário Camboriú — fácil acesso para
          balanceamento, geometria, troca de óleo, freios e revisões completas.
        </p>
        <div className="mt-9 flex flex-wrap gap-4">
          <a
            data-testid="location-directions-button"
            href={MAPS_DIRECTIONS}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-cut inline-flex items-center gap-2 px-8 py-4 border border-white/25 text-white hover:border-volt hover:text-volt font-display font-bold uppercase tracking-wide text-lg transition-colors duration-300"
          >
            Como Chegar
            <ArrowUpRight className="h-5 w-5" />
          </a>
          <a
            data-testid="location-whatsapp-button"
            href={waLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-cut inline-flex items-center gap-2 px-8 py-4 bg-signal hover:bg-signalhover text-white font-display font-bold uppercase tracking-wide text-lg transition-colors duration-300"
          >
            <MessageCircle className="h-5 w-5" />
            Solicitar Avaliação
          </a>
        </div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: 40 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="border border-white/[0.08] overflow-hidden"
        data-testid="location-map"
      >
        <iframe
          title="Mapa — MW Auto Center, Rua Alvim Bauer 806, Balneário Camboriú"
          src={MAPS_EMBED}
          className="w-full h-[380px] lg:h-[480px]"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </motion.div>
    </div>
  </section>
);
